import React, { useEffect, useState } from "react";
import { Navbar, Footer } from "../hrcomponents";
import axios from "axios";
import configData from "../config.json";
import * as Icon from "react-bootstrap-icons";
import { format } from "date-fns";
import Select from "react-select";
import {useParams, useNavigate, useLocation} from 'react-router-dom';

const AttendanceAdjustment = () => {
  if (localStorage.getItem("branchID") === null) {
    window.location.replace("/hris");
  }

  const navigate=useNavigate();
  const location = useLocation();

  const [empData, setEmpData] = useState([]);
  const [eventData, setEventData] = useState([]);
  const [empID, setEmpId] = useState("");

  const [inputData, setInputData] = useState({
    dateFrom: "",
    dateTo: "",
    entryTime: format(new Date(), "HH:mm:ss"),
    exitTime: format(new Date(), "HH:mm:ss"),
    description: "",
  });

  const handleInput = (e) => {
    const { name, value } = e.target;

    setInputData({
      ...inputData,
      [name]: value,
    });
  };

  useEffect(() => {
    const getEmpData = async () => {
      try {
        const response = await axios.get(
          configData.SERVER_URL +
            `/empData/${localStorage.getItem("branchID")}`
        );

        setEmpData(response.data);
      } catch (error) {
        console.log(error);
      }
    };

    getEmpData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!inputData.dateFrom || !inputData.dateTo) {
      alert("Both Dates are required.");
      return;
    }

    if (inputData.dateFrom > inputData.dateTo) {
      alert("Invalid Date Selection...");
      return;
    }

    const payload = {
      ...inputData,
      empID: empID,
    };

    try {
      const res = await axios.post(
        configData.SERVER_URL + `/eventData`,
        payload
      );

      setEventData(res.data);

      if (res.status === 200) {
        alert("Successfully Inserted");
      } else {
        alert("System Error");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const empOptions = empData.map((d) => ({
    value: String(d.id),
    label: `${d.empCode} | ${d.empName} | ${d.NID}`,
  }));

  const reasonOptions = [
    { value: "Informed", label: "Informed" },
    { value: "Audit Work", label: "Audit Work" },
    { value: "Office Duty", label: "Office Duty" },
    { value: "Tour", label: "Tour" },
    { value: "Local Training",label: "Local Training",},
    {value: "Foreign Training",label: "Foreign Training",},
  ];

  return (
    <>
      <div
        className="container">
        {/* Main Card */}
        <div
          className="card border-0 shadow-lg mb-4"
          style={{
            borderRadius: "20px",
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <div
            className="card-header"
            style={{
              background:
                "linear-gradient(135deg, #0d6efd, #6610f2)",
              color: "#fff",
              padding: "22px",
            }}
          >
            <div className="d-flex align-items-center">
              <Icon.CalendarCheck
                size={28}
                className="me-3"
              />

              <div>
                <h3 className="fw-bold mb-1">
                  Attendance Adjustment
                </h3>

                <small>
                  Manual attendance correction and approval
                </small>
              </div>
            </div>
          </div>

          {/* Form Body */}
          <div
            className="card-body"
            style={{
              backgroundColor: "#f8f9fa",
              padding: "30px",
            }}
          >
            <div className="row g-4">
              {/* Employee */}
              <div className="col-lg-6 col-md-12">
                <label className="form-label fw-semibold">
                  Employee
                </label>

                <Select
                  options={empOptions}
                  isSearchable
                  placeholder="Search Employee..."
                  menuPortalTarget={document.body}
                  menuPosition="fixed"

                  onChange={(selectedOption) => {
                    setEmpId(
                      selectedOption
                        ? selectedOption.value
                        : null
                    );
                  }}
                />
              </div>

              {/* Date From */}
              <div className="col-lg-3 col-md-6">
                <label className="form-label fw-semibold">
                  Date From
                </label>

                <input
                  type="date"
                  className="form-control shadow-sm"
                  name="dateFrom"
                  value={inputData.dateFrom}
                  onChange={handleInput}
                  style={{
                    borderRadius: "10px",
                    height: "45px",
                  }}
                />
              </div>

              {/* Date To */}
              <div className="col-lg-3 col-md-6">
                <label className="form-label fw-semibold">
                  Date To
                </label>

                <input
                  type="date"
                  className="form-control shadow-sm"
                  name="dateTo"
                  value={inputData.dateTo}
                  onChange={handleInput}
                  style={{
                    borderRadius: "10px",
                    height: "45px",
                  }}
                />
              </div>

              {/* Entry Time */}
              <div className="col-lg-3 col-md-6">
                <label className="form-label fw-semibold">
                  Entry Time
                </label>

                <input
                  type="time"
                  step="60"
                  className="form-control shadow-sm"
                  name="entryTime"
                  value={inputData.entryTime}
                  onChange={handleInput}
                  style={{
                    borderRadius: "10px",
                    height: "45px",
                  }}
                />
              </div>

              {/* Exit Time */}
              <div className="col-lg-3 col-md-6">
                <label className="form-label fw-semibold">
                  Exit Time
                </label>

                <input
                  type="time"
                  step="1"
                  className="form-control shadow-sm"
                  name="exitTime"
                  value={inputData.exitTime}
                  onChange={handleInput}
                  style={{
                    borderRadius: "10px",
                    height: "45px",
                  }}
                />
              </div>

              {/* Reason */}
              <div className="col-lg-4 col-md-8">
                <label className="form-label fw-semibold"> Reason </label>

                <Select
                  options={reasonOptions}
                  placeholder="Select Reason..."
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  onChange={(selectedOption) => {
                    setInputData((prev) => ({
                      ...prev,
                      description: selectedOption ? selectedOption.value : "",
                    }));
                  }}
                />
              </div>

              {/* Submit */}
              <div className="col-lg-2 col-md-4 d-flex align-items-end">
                <button
                  type="button"
                  className="btn btn-success w-100 shadow-sm"
                  onClick={handleSubmit}
                  style={{ borderRadius: "10px", height: "45px", fontWeight: "600", }}
                  disabled={location?.state?.menu?.isInsert !== "Y"}
                >
                  <Icon.CheckCircle className="me-2" />
                  POST
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Attendance Details */}
        <div
          className="card border-0 shadow-lg"
          style={{
            borderRadius: "20px",
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <div
            className="card-header d-flex justify-content-between align-items-center"
            style={{
              background:
                "linear-gradient(135deg, #198754, #20c997)",
              color: "#fff",
              padding: "18px 20px",
            }}
          >
            <h5 className="mb-0 fw-bold">
              Attendance Details
            </h5>

            <span className="badge bg-light text-dark px-3 py-2">
              Total : {eventData?.length || 0}
            </span>
          </div>

          {/* Table */}
          <div
            className="card-body"
            style={{
              backgroundColor: "#fff",
            }}
          >
            <div className="table-responsive">
              <table className="table table-hover table-bordered align-middle">
                <thead
                  style={{
                    backgroundColor: "#198754",
                    color: "#fff",
                  }}
                >
                  <tr>
                    <th>#</th>
                    <th>Event Date</th>
                    <th>Entry Time</th>
                    <th>Exit Time</th>
                    <th>Remark</th>
                    <th>Description</th>
                  </tr>
                </thead>

                <tbody>
                  {eventData &&
                    eventData.length > 0 &&
                    eventData.map((data, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>

                        <td>
                          {format(
                            new Date(data.eventDate),
                            "dd-MM-yyyy"
                          )}
                        </td>

                        <td>
                          <span className="badge bg-primary px-3 py-2">
                            {data.entryTime}
                          </span>
                        </td>

                        <td>
                          <span className="badge bg-success px-3 py-2">
                            {data.exitTime}
                          </span>
                        </td>

                        <td>
                          <span className="text-danger fw-semibold">
                            {data.remarks}
                          </span>
                        </td>

                        <td>
                          <span className="badge bg-info text-dark px-3 py-2">
                            {data.description}
                          </span>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>

              {eventData.length === 0 && (
                <div className="alert alert-warning text-center mt-3">
                  No attendance adjustment records found.
                </div>
              )}
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default AttendanceAdjustment;